import QuoteDetailsTabs from './QuoteDetailsTabs';

export default QuoteDetailsTabs;
